<template>
  <div class="page-wrap">

    <!-- Confirm reschedule dialog -->
    <transition name="fade">
      <div class="overlay" v-if="showConfirm" @click.self="showConfirm = false">
        <div class="confirm-dialog">
          <div class="cd-icon-wrap">
            <i class="fa fa-calendar-check"></i>
          </div>
          <div class="cd-title">Confirm Reschedule</div>
          <div class="cd-sub">You're about to reschedule this appointment to:</div>
          <div class="cd-detail-card">
            <div class="cdc-row">
              <i class="fa fa-calendar-alt"></i>
              <span>{{ confirmDate }}</span>
            </div>
            <div class="cdc-row">
              <i class="fa fa-clock"></i>
              <span>{{ confirmTime }}</span>
            </div>
            <div class="cdc-row muted">
              <i class="fa fa-user"></i>
              <span>{{ fullname }} — #{{ getAppointmentRescheduleDetail.id }}</span>
            </div>
          </div>
          <div class="confirm-footer">
            <button class="btn-cd-cancel" @click="showConfirm = false">
              <i class="fa fa-times"></i> Cancel
            </button>
            <button class="btn-cd-confirm" @click="doReschedule()" :disabled="saveDataLoader">
              <i class="fa fa-check"></i> Yes, Reschedule
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Full-screen saving overlay -->
    <transition name="fade">
      <div class="processing-overlay" v-if="saveDataLoader">
        <div class="processing-card">
          <i class="fa fa-circle-o-notch fa-spin"></i>
          <div class="processing-title" v-html="loadingMessage"></div>
        </div>
      </div>
    </transition>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-calendar-alt"></i></div>
          <div>
            <div class="panel-title">Reschedule Appointment</div>
            <div class="panel-sub">Select a new date and time slot below</div>
          </div>
        </div>
        <button class="btn-back" @click="back()">
          <i class="fa fa-arrow-left"></i> Go Back
        </button>
      </div>

      <!-- Appointment info strip -->
      <div class="info-strip">
        <div class="info-chip">
          <span class="ic-label">Appointment #</span>
          <span class="ic-val">{{ getAppointmentRescheduleDetail.id }}</span>
        </div>
        <div class="info-divider"></div>
        <div class="info-chip">
          <span class="ic-label">Applicant</span>
          <span class="ic-val">{{ fullname }}</span>
        </div>
      </div>

      <!-- Calendar -->
      <div class="calendar-wrap">
        <f-calender :back_end="true"></f-calender>
      </div>

      <!-- Footer actions -->
      <div class="panel-footer">
        <button class="btn-cancel" @click="back()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button class="btn-submit" @click="submitReschedule()">
          <i class="fa fa-check"></i> Confirm Reschedule
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import fCalender from "@/pages/frontend/booknow/calender";
import { mapGetters } from "vuex";
import {
  STORE_RESCHEDULE_TIMES,
  FETCH_NOTES
} from "@/core/services/store/actions.type";
import {
  SET_APPOINTMENT_TIME,
  SET_SCHEDULE_TIMES,
  SET_APPOINTMENT_DATE,
  SET_APPOINTMENT_FOR_RESCHEDULE,
  SET_BREADCRUMB
} from "@/core/services/store/mutations.type";

export default {
  components: { fCalender },
  data() {
    return {
      saveDataLoader: false,
      loadingMessage: "",
      showConfirm: false,
      confirmDate: "",
      confirmTime: "",
      pendingData: null,
      breadCrumbs: [
        { id: 1, title: "Dashboard",           route: "client.dashboard" },
        { id: 2, title: "Appointment List",     route: "client.appointment.index" },
        { id: 3, title: "Appointment Reschedule", route: "" }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getfrontAppointmentTime",
      "getfrontAppointmentDate",
      "getTimeZone",
      "getAppointmentRescheduleDetail"
    ]),
    fullname() {
      const d = this.getAppointmentRescheduleDetail;
      let name = d.fname || "";
      if (d.mname) name += " " + d.mname;
      name += " " + (d.lname || "");
      return name.trim();
    }
  },
  created() {
    if (this.getTimeZone == "") { this.$router.go(-1); return; }
    this.breadCrumbs[2].title = "Appointment Reschedule For #" + this.getAppointmentRescheduleDetail.id;
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_NOTES);
    this.$store.commit(SET_APPOINTMENT_TIME, null);
  },
  methods: {
    back() { this.$router.go(-1); },
    submitReschedule() {
      if (!this.getfrontAppointmentTime) {
        this.$toastr.w("Please select a reschedule time");
        return;
      }
      const date = this.$moment(this.getfrontAppointmentDate).format("YYYY-MM-DD");
      const time = this.timeFormat(this.getfrontAppointmentTime.start_time, this.getfrontAppointmentDate);
      this.pendingData = {
        app_id:        this.$route.params.app_id,
        token:         this.$route.params.token,
        client_id:     this.$route.params.id,
        schedule_date: date,
        schedule_time: this.getfrontAppointmentTime.start_time,
        time:          { start: time }
      };
      this.confirmDate  = this.$moment(date).format("MMMM D, YYYY");
      this.confirmTime  = time;
      this.showConfirm  = true;
    },
    doReschedule() {
      this.showConfirm = false;
      this.loadingMessage = "Please wait…<br>Rescheduling your appointment";
      this.saveDataLoader = true;
      this.$store.dispatch(STORE_RESCHEDULE_TIMES, this.pendingData)
        .then(res => {
          if (res.code == 200) {
            this.$toastr.s(res.msg);
            this.saveDataLoader = false;
            this.$store.commit(SET_APPOINTMENT_TIME, null);
            this.$store.commit(SET_APPOINTMENT_DATE, "");
            this.$store.commit(SET_SCHEDULE_TIMES, []);
            this.$store.commit(SET_APPOINTMENT_FOR_RESCHEDULE, null);
            this.$router.go(-1);
          }
        })
        .catch(errs => {
          this.$toastr.e(errs.msg);
          this.saveDataLoader = false;
        });
    },
    timeFormat(value, date) {
      return this.$moment(date + " " + value).format("hh:mm a");
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 40px;
  font-family: $font;
}

/* ── Confirm dialog overlay ── */
.overlay {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(13,27,62,0.4);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.confirm-dialog {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(13,27,62,0.18);
  width: 100%;
  max-width: 380px;
  overflow: hidden;
  animation: pop-in 0.2s ease;
}

@keyframes pop-in {
  from { transform: scale(0.92); opacity: 0; }
  to   { transform: scale(1);    opacity: 1; }
}

.cd-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 24px 8px;

  i {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #dbeafe;
    color: $blue;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}

.cd-title {
  font-size: 16px;
  font-weight: 700;
  color: $dark;
  text-align: center;
  padding: 10px 24px 4px;
}

.cd-sub {
  font-size: 12.5px;
  color: #7a8499;
  text-align: center;
  padding: 0 24px 16px;
}

.cd-detail-card {
  margin: 0 20px 20px;
  background: #f5f8fe;
  border: 1px solid #e0e8f7;
  border-radius: 10px;
  overflow: hidden;
}

.cdc-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #e8edf5;
  font-size: 13px;
  font-weight: 600;
  color: $dark;

  &:last-child { border-bottom: none; }

  &.muted { color: #7a8499; font-weight: 400; }

  i {
    width: 16px;
    text-align: center;
    color: $blue;
    font-size: 12px;
    flex-shrink: 0;
  }
}

.confirm-footer {
  display: flex;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #eef0f8;
  background: #fafbfd;

  .btn-cd-cancel {
    flex: 1;
    height: 38px;
    border: 1.5px solid #dde2ec;
    background: #fff;
    color: #4a5568;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.15s;

    &:hover { border-color: #e53e3e; color: #e53e3e; }
  }

  .btn-cd-confirm {
    flex: 1;
    height: 38px;
    border: none;
    background: $green;
    color: #fff;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: opacity 0.15s;

    &:hover   { opacity: 0.9; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }
}

/* ── Processing overlay ── */
.processing-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(13,27,62,0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.processing-card {
  background: #fff;
  border-radius: 14px;
  padding: 32px 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(13,27,62,0.18);

  i {
    font-size: 28px;
    color: $blue;
    margin-bottom: 12px;
    display: block;
  }
}

.processing-title {
  font-size: 13px;
  color: $dark;
  font-family: $font;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to           { opacity: 0; }

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13,27,62,0.07);
  overflow: hidden;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 12px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  background: #fff;
  color: #4a5568;
  border: 1.5px solid $border;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: $blue; color: $blue; }
}

/* ── Info strip ── */
.info-strip {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 12px 20px;
  background: #f5f8fe;
  border-bottom: 1px solid #e8edf5;
  flex-wrap: wrap;
  gap: 16px;
}

.info-chip {
  display: flex;
  align-items: center;
  gap: 8px;

  .ic-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #a0aab8;
  }

  .ic-val {
    font-size: 13px;
    font-weight: 600;
    color: $dark;
  }
}

.info-divider {
  width: 1px;
  height: 20px;
  background: #dde4f5;
}

/* ── Calendar ── */
.calendar-wrap {
  padding: 24px 20px;
}

/* ── Footer ── */
.panel-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  background: #fafbfd;
  border-top: 1px solid #eef0f6;
}

.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 18px;
  background: #fff;
  color: #4a5568;
  border: 1.5px solid $border;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { border-color: #e53e3e; color: #e53e3e; }
}

.btn-submit {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 22px;
  background: $green;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover { opacity: 0.9; }
}
</style>
